var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 35,
    width: 35,
    height: 35,
    rx: 5,
    transform: "rotate(-180 35 35)",
    fill: "#7FF6B6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7071 11.2929C17.3166 10.9024 16.6834 10.9024 16.2929 11.2929L9.92893 17.6569C9.53841 18.0474 9.53841 18.6805 9.92893 19.0711C10.3195 19.4616 10.9526 19.4616 11.3431 19.0711L17 13.4142L22.6569 19.0711C23.0474 19.4616 23.6805 19.4616 24.0711 19.0711C24.4616 18.6805 24.4616 18.0474 24.0711 17.6569L17.7071 11.2929ZM18 26L18 12L16 12L16 26L18 26Z",
    fill: "#4BB543"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrow);
export default __webpack_public_path__ + "static/media/green_arrow.f31998cacee0a7ae84d8a0352e412093.svg";
export { ForwardRef as ReactComponent };